export var PreviewFileType;
(function (PreviewFileType) {
    PreviewFileType["IMAGE"] = "IMAGE";
    PreviewFileType["PDF"] = "PDF";
    PreviewFileType["WORD"] = "WORD";
    PreviewFileType["EXCEL"] = "EXCEL";
    PreviewFileType["XML"] = "XML";
    PreviewFileType["OTHER"] = "OTHER";
})(PreviewFileType || (PreviewFileType = {}));
const pdfExtensionPattern = /[^\\s]+(.*?)\.(pdf|PDF)$/;
const xmlExtensionPattern = /[^\\s]+(.*?)\.(xml|XML)$/;
const imageExtensionPattern = /[^\\s]+(.*?)\.(jpg|jpeg|png|gif|JPG|JPEG|PNG|GIF)$/;
const wordExtensionPattern = /[^\\s]+(.*?)\.(doc|docx|dot|dotx|DOC|DOCX|DOT|DOTX)$/;
const excelsExtensionPattern = /[^\\s]+(.*?)\.(xls|xlsx|xlsm|csv|XLS|XLSX|XLSM|CSV)$/;
export const PatternValidate = {
    pdfExtensionPattern,
    xmlExtensionPattern,
    imageExtensionPattern,
    wordExtensionPattern,
    excelsExtensionPattern,
};
